import React, { Component } from "react";
import ReactDOM from "react-dom";
import Axios from "axios";
import _ from "lodash";
import Notice from "Components/Notice";
import Loading from "Components/Loading";
import { ControlTip } from "Components/ControlTip";
import Gzip from "./gzip";
import { GetQuery, langCheck, getWindow, DEFAULT_LOGOUT_URL, getTopWorkbenchWin } from "Pub/js/utils";
import { getStore, setStore } from 'Pub/js/storageUtils';
import Cipher, { opaqueDecrypt } from "./cipher"; // bbqin
import platform from "Pub/js/platform";
const { ajax } = platform;

Axios.defaults.headers.post["Content-Type"] = "application/json";

const getIdentifications = function (data, headers = {}) {
    if (
        typeof transSn !== 'undefined' &&
        typeof transSign !== 'undefined'
    ) {
        headers['Identifications'] = transSign(JSON.stringify(data) + '', '');
        if (!headers.hasOwnProperty('transcode')) {
            headers['transcode'] = "10228888"; //appcode
        }
    }
    return headers;
};

// 处理错误信息 处理network error 以及 Failed to execute 'send' on 'XMLHttpRequest'
function networkErrorStatusCatchHandle(request = {}, error = {}, url) {
    let data = { type: 'error', message: langCheck("0000PUB-000504") || 'Network Error' };

    // error.name 同步的是请求是NetworkError  异步的时候没有名称
    // 默认报错拦截处理
    const defaultMessage = typeof (error.message) === 'string' ? error.message : JSON.stringify(error.message);

    const messageKey1 = "Failed to execute 'send' on 'XMLHttpRequest";
    const messageKey2 = "Network Error";

    if (defaultMessage && request.status === 0 && request.readyState === 4 &&
        (defaultMessage.includes(messageKey1) || defaultMessage.includes(messageKey2))
    ) {
        // data.message = `${langCheck("0000PUB-000504") || 'Network Error'}; url:${url}`;
        data.message = `${langCheck("0000PUB-000504") || 'Network Error'}`;
        Notice({ status: data.type || "error", msg: data.message });
        return null;
    }
    return true;
}

/**
 * 目前主要处理 500
 * @param {*} error
 * @param {*} tipCallBack
 * @param {*} url
 */
const errorStatusCatchHandle = function (error = {}, url, headers) {
    let data = {
            type: 'error',
            message: langCheck("0000PUB-000381") || 'Service Unavailable',
        },
        status = error.status || (error.response ? error.response.status : 200);

    if (status === 500 || status === 503 || status === 502) {
        data.message = `"${headers['nccloud-service'] || ''}" ${langCheck("0000PUB-000381") || 'Service Unavailable'}; url:${url},status: ${status}`;
        data.message = data.message.replace(/nccloud\//g, '');
        Notice({ status: data.type || "error", msg: data.message });
        return null;
    }

    if (status === 504) {
        data.message = `"${headers['nccloud-service'] || ''}" ${langCheck("0000PUB-000382") || 'Gateway Timeout'}; url:${url},status: ${status}`;
        data.message = data.message.replace(/nccloud\//g, '');
        Notice({ status: data.type || "error", msg: data.message });
        return null;
    }

    return error;
};

/**
 * 获取 Cookie
 * @param {String} key
 */
export const getCookie = key => {
    let cookies = document.cookie;
    let allCookies = cookies.split("; ").reduce((o, item) => {
        let arr = item.split("=");
        let firstIndex = item.indexOf("=");
        o[item.substring(0, firstIndex)] = item.substring(firstIndex + 1);
        return o;
    }, {});
    if (key) {return allCookies[key];}
    return allCookies;
};
/**
 * 设置 Cookie
 * @param {String} key
 * @param {Object} value
 * @param {String} day
 */
export const setCookie = (key, value, path, domain, day) => {
    value = JSON.stringify(value);
    let expires = "",
        setPath,
        setdomain;
    if (day) {
        let d = new Date();
        d.setDate(d.getDate() + day);
        expires = "; expires=" + d.toUTCString();
    }
    if (path) {
        setPath = `; path=${path}`;
    } else {
        setPath = "; path=/nccloud";
    }
    if (domain) {
        setdomain = `; setdomain=${domain}`;
        // 解决sonar 检测
        // document.cookie = key + "=" + value + expires + setPath + setdomain;
    } else {
        // 解决sonar 检测
        // document.cookie = key + "=" + value + expires + setPath;
    }
};

let LOGOUT = false;
// 此时的cookie是当前界面唯一 如果放到ajax内部
// 多个请求的情况下 会导致前面的cookie被覆盖  所有请求用的是第二次的cookie  而加密用的cookie是第一次的
// 实际环境中，我们应该是在workbench这个壳子时就创建了cookiets
let cookiets = window.cookiets || window.cookiets || getCookie("cookiets") || Date.now(); //双cookie验证 liuxis
// 做一次 数据转型
cookiets = isNaN(cookiets) ? cookiets : Number(cookiets);
setCookie("cookiets", cookiets);
window.cookiets = cookiets;
// let ts = Date.parse(new Date());

/**
 * ajax请求方法
 */
const Ajax = params => {
    if (true) {
        // console.log('ajax-platform');
        const resParams = { ...params };
        const { success, error } = resParams;
        if (!resParams.sysAppcode) {
            const { c } = GetQuery(window.location.hash);
            const appcode = resParams.info && resParams.info.appcode;
            resParams.sysAppcode = appcode || c || '10228888';
        }
        /**
         * 请求loading platform的不生效，这边处理一下
         */
        const { loading, toastContainer } = params;
        let loadingContainer;
        if (loading) {
            loadingContainer = document.createElement("div");
            document.body.appendChild(loadingContainer);
            ReactDOM.render(<Loading config={{ fullScreen: true }}/>, loadingContainer);
        }
        ajax({
            ...resParams,
            loading: false,
            success: res => {
                success && success({ data: res }); // 包装一层，将platform-ajax的结构处理成workbench可用的
                if (loading) {
                    ReactDOM.unmountComponentAtNode(loadingContainer);
                    loadingContainer.remove();
                }
            },
            error: err => {
                Notice({
                    status: err.type || 'danger',
                    msg: err.message,
                    container: toastContainer
                });
                if (loading) {
                    ReactDOM.unmountComponentAtNode(loadingContainer);
                    loadingContainer.remove();
                }
                error && error({ data: { error: err } });
            }
        });
        return;
    }

    let aeskey = opaqueDecrypt(getStore("cowboy"));
    // 解决 接口报错 清理本地的cookie的情况 报错 by bbqin
    params.headers = params.headers || {};

    cookiets = params.headers['cookiets'] = String(params.headers['cookiets'] || (window.cookiets || getCookie('cookiets') || Date.now()));
    setCookie('cookiets', cookiets);

    let crux = params.headers['crux'] = String(params.headers['crux'] || (new Date().getTime()));

    // 刷新一下  bbqin
    aeskey = opaqueDecrypt(getStore("cowboy"));
    let cruxId = String(crux);
    aeskey = cruxId + aeskey.substring(0, aeskey.length - cruxId.length);
    // 加密 bbqin
    let cipherFlag = getStore("rockin") == true;
    // 将是否加密缓存到组件单例上
    Cipher.CipherFlag = cipherFlag;
    return AjaxPromise(params, aeskey);
};

/**
 * 同步处理 是否启用压缩
 */
const AjaxPromise = (params, aeskey) => {
    let gzipSwitch = getGlobalStore("gzip");
    if (gzipSwitch !== null) {
        getAesSwitch(params, () => {
            caSecurity(params, aeskey); //加签
        }); //加密
    } else {
        let gzipSwitchParams = {
            sysParamJson: {
                busiaction: `${langCheck("0000PUB-000078")}-${langCheck(
                    "0000PUB-000079",
                )}` /* 国际化处理： 流量压缩,查询*/,
                ts: new Date().getTime(),
                pagecs: cookiets,
            },
        };
        // 加签
        let headers = getIdentifications(gzipSwitchParams, params.headers || {});
        Axios({
            url: `/nccloud/platform/gzip/switch.do`,
            method: "post",
            data: gzipSwitchParams,
            headers,
            async: false,
        })
            .then(res => {
                if (res.status === 200) {
                    let {
                        data: {
                            success: successStatus,
                            error: errorStatus,
                            data,
                        },
                    } = res;
                    if (successStatus) {
                        setGlobalStore("gzip", data ? 1 : 0);
                        getAesSwitch(params, () => {
                            caSecurity(params, aeskey); //加签
                        }); //加密
                    } else {
                        Notice({ status: errorStatus.type || "error", msg: errorStatus.message, mark: `${errorStatus.message}workbenchTip` });
                    }
                }
            })
            .catch(error => { });
    }
};
/**
 * ca 安全 加签       是否是有请求数据的才进行加签
 */
const caSecurity = (params, aeskey) => {
    // 获取压缩标识
    let gzipSwitch = getGlobalStore("gzip");
    // 获取加签标识
    let isNccSign = getGlobalStore("isNccSign");
    // 默认加签
    // let isNccSign = true;
    gzipSwitch = JSON.parse(gzipSwitch);
    let reqData = {
        sysParamJson: {
            busiaction: langCheck(
                "0000PUB-000071",
            ), /* 国际化处理： 查询请求安全加签开关*/
            pagecs: cookiets,
        },
    };
    // 加签
    let headers = getIdentifications(reqData, params.headers || {});
    reqData = JSON.stringify(reqData);
    let gziptools;
    if (gzipSwitch) {
        gziptools = new Gzip();
        reqData = gziptools.zip(reqData);
    }
    if (isNccSign !== null) {
        AjaxMain(params, aeskey);
    } else {
        // ***************************************************
        // 此处逻辑不执行，要求一定启用加签功能
        Axios({
            url: `/nccloud/platform/mark/switch.do`,
            method: "post",
            data: reqData,
            async: false,
            headers,
            transformResponse: [
                function (data, headers) {
                    // 对 data 进行任意转换处理
                    let gData;
                    // 是否启动压缩
                    if (gzipSwitch) {
                        gData = gziptools.unzip(data);
                    } else {
                        gData = JSON.parse(data);
                    }
                    return gData;
                },
            ],
        })
            .then(res => {
                if (res.status === 200) {
                    let {
                        data: {
                            success: successStatus,
                            error: errorStatus,
                            data,
                        },
                    } = res;
                    if (successStatus) {
                        setGlobalStore("isNccSign", data);
                        AjaxMain(params, aeskey);
                    } else {
                        Notice({ status: errorStatus.type || "error", msg: errorStatus.message, mark: `${errorStatus.message}workbenchTip` });
                    }
                }
            })
            .catch(error => { });
        // *****************************************************
    }
};

/**
 * Ajax 主要函数
 * @param {String} url 请求地址
 * @param {Object} data 请求数据
 * @param {String} method 请求方法 get/post
 * @param {Boolen} switchKey 是否启用压缩
 * @param {Boolen} loading 是否开启loading
 * @param {Object} info 请求描述对象 name - 发起请求的应用名称  action - 发起请求的动作
 * @param {Function} success 请求成功回调
 */
const AjaxMain = (params, aeskey) => {
    let {
        url,
        data,
        method = "post",
        switchKey = false,
        loading = false,
        info = { name: "", action: "" },
        success = res => {
            // console.log(res);
        },
        error = res => {

        },
        noNeedShowError,
        errorCatch,
    } = params;
    let userInfos = window.GETBUSINESSINFO ? window.GETBUSINESSINFO() : null;
    let userCode = userInfos && userInfos.userCode ? userInfos.userCode : null;
    let { c } = GetQuery(window.location.hash);
    let appcode = info.appcode ? info.appcode : c ? c : "10228888";
    let div;
    let gzipSwitch = getGlobalStore("gzip");
    gzipSwitch = JSON.parse(gzipSwitch);
    let gziptools = new Gzip();
    let { n } = GetQuery(window.location.hash);
    data = {
        busiParamJson: JSON.stringify(data),
        sysParamJson: {
            busiaction: `${n || langCheck("0000PUB-000105")}-${info.action}`,
            appcode: appcode,
            ts: new Date().getTime(),
            pagecs: cookiets,
        },
    };
    // 去除局部 使用全部数据加签 加签 -- bbqin
    let isNccSign = getGlobalStore("isNccSign");
    //headers加appcode
    let commonHeaders = params.headers || {};
    commonHeaders.transcode = appcode;
    let headers = (isNccSign === 'true' || isNccSign === true) ? getIdentifications(data, commonHeaders) : commonHeaders;

    // 判断当前是否为退出操作
    if (url.indexOf("logout") !== -1) {
        LOGOUT = true;
    }
    /**
     * 请求loading
     */
    if (loading) {
        div = document.createElement("div");
        document.body.appendChild(div);
        ReactDOM.render(<Loading config={{ fullScreen: true }}/>, div);
    }
    /**
     * 开启报错提示
     */
    let flag = true;
    Axios({
        url,
        data,
        method,
        headers,
        validateStatus: function (status) {
            //以前的注销逻辑挪到logout接口里
            return status < 500;
        },
        transformRequest: [
            function (data) {
                // 不压缩
                let gData = JSON.stringify(data);
                // 启动压缩
                if (!switchKey && gzipSwitch) {
                    gData = gziptools.zip(gData);
                }
                return Cipher.encrypt(gData, aeskey);
            },
        ],
        transformResponse: [
            function (data, headers) {
                // 用户离线状态，并返回到登录页
                if (headers.redirect === "REDIRECT") {
                    flag = false;
                    SpecialTip(
                        headers.redirectstatus,
                        exitPage,
                        headers.contentpath,
                    );
                    return;
                }
                // 是否存在contentpath 只有401时可能存在
                if (headers.contentpath) {
                    // 是否打开新页签，如果打开将其关闭
                    // if (
                    //     window.newwindow &&
                    //     window.newwindow.location.origin == "null"
                    // ) {
                    //     window.newwindow.close();
                    // }
                    // 鉴权提示
                    if (headers.authorize === "FALSE") {
                        Notice({
                            status: "error",
                            msg: langCheck(
                                "0000PUB-000072",
                            ), /* 国际化处理： 该请求未配置鉴权信息*/
                        });
                        return false;
                    } else {
                        exitPage(headers.contentpath);
                    }
                }
                if (headers.environmentmodel) {
                    window.environmentmodel = headers.environmentmodel;
                }

                // 对 data 进行任意转换处理
                let gData;
                // 先解密 bbqin
                try {
                    //容错一下，为解决注销只有压缩没有加密
                    data = typeof data === "string" ? Cipher.decrypt(data, aeskey) : data;
                } catch (error) {
                    // return null
                }

                try {
                    // 启动压缩
                    if (!switchKey && gzipSwitch) {
                        gData = gziptools.unzip(data);
                    } else {
                        gData = JSON.parse(data);
                    }
                } catch (error) {
                    // return null
                }
                return gData;
            },
        ],
    })
        .then(res => {
            if (res.status === 200) {
                let { data: { success: successStatus, error: errorStatus } } = res;
                if (successStatus) {
                    success(res);
                } else {
                    error(res);
                    !noNeedShowError && Notice({ status: errorStatus.type || "error", msg: errorStatus.message });
                }
                if (loading) {
                    ReactDOM.unmountComponentAtNode(div);
                }
            } else if (res.status === 4147) {
                // TODO 是否和platform一样的提示
                Notice({ status: "error", msg: langCheck("0000PUB-000383") });
            }
        })
        .catch(error => {
            let number = error.number;
            console.log(number);
            // -2147467259 -未指名错误   -2147024891 -拒绝访问错误
            if (number === -2147467259 || number === -2147024891) {
                return;
            }

            //errorCatch捕获错误信息 
            if(errorCatch && !errorCatch(error)) {
                return;
            }

            if (!networkErrorStatusCatchHandle(error.request, error, url)) {
                return;
            }

            if (!errorStatusCatchHandle(error, url, error.response ? error.response.headers : {})) {
                return null;
            }

            if (flag) {
                if (error.message === "") {
                    error.message = langCheck(
                        "0000PUB-000073",
                    ); /* 国际化处理： 未知类型错误！*/
                }
                Notice({ status: error.type || "error", msg: error.message });
            }
        });
};
/**
 * 强制退出提示
 * @param {Function} callback 回调
 * @param {String} status 状态
 * @param {String} paramData 参数数据
 */
const SpecialTip = function() {
    getTopWorkbenchWin().SpecialTipFunc(...arguments);
}
window.SpecialTipFunc = (status, callback, paramData = DEFAULT_LOGOUT_URL) => {
    if (document.querySelector(".prompt-abnormal-exit") === null) {
        let otherProps = {};
        if (status === '1') { //被踢
            otherProps = { okText: langCheck("0000PUB-000370"), /* 国际化处理： 退出*/ };
        }
        const storeInfoData = getStore('STOREFORINFODATA');
        const redirectLogin = () => {
            localStorage.removeItem('STOREFORINFODATA'); // 被踢时清空用户信息
            // callback(paramData);
            // callback可能是platform传过来的，弃用，使用工作桌面的退出即可
            exitPage(paramData);
        }
        ControlTip({
            fieldid: 'abnormal-exit',
            status: "warning",
            title: langCheck("0000PUB-000074") /* 国际化处理： 退出警告！*/,
            zIndex: 1200,
            containerClassName: 'prompt-abnormal-exit',
            className: "zIndex10000",
            msg: switchStatus(status),
            isCancelBtn: false,
            onOk: redirectLogin,
            ...otherProps,
            // 没有storeInfoData表明没有登陆过或者清了浏览器缓存，不需要登录
            // 登录组件名称是通过GETBUSINESSINFO获取的，能取到才能登录
            // 经领导讨论，去掉当前页登录的功能
            // redirectLoginFunc: window.GETBUSINESSINFO && window.GETBUSINESSINFO().userCode && storeInfoData ? redirectLogin : null,
        });
        window.__exitTipFlag = true; //显示弹框设置flag
        if (storeInfoData) {
            storeInfoData.abnormalExited = true; // 记录异常退出标识
            setStore('STOREFORINFODATA', storeInfoData);
        }
    }
    if (LOGOUT) {
        callback(paramData);
    }
};
window.SpecialTip = SpecialTip;
/**
 * 状态选择
 */
const switchStatus = status => {
    switch (status) {
        case "0":
            return langCheck("0000PUB-000075"); /* 国际化处理： 用户没有登录，即将跳转到登录页面。 */
        case "1":
            return langCheck("0000PUB-000076"); /* 国际化处理： 当前账号在其他设备登录，若非本人操作请尽快修改密码！ */
        case "2":
            return langCheck("0000PUB-000077"); /* 国际化处理： 管理员在系统监视器进行了强制踢出操作！你已被踢出系统! */
        case "3":
            return langCheck("0000PUB-000470"); /* 国际化处理： 用户会话已失效，请重新登录！ */
    }
};
/**
 * 设置全局 store
 * @param {String} key
 * @param {Object} value
 */
const setGlobalStore = (key, value) => {
    let infosFromCookie = getCookie(key);
    let infosFromLocalStorage = getStore(key);
    if (!infosFromCookie && !infosFromLocalStorage) {
        setCookie(key, value);
        if (!getCookie(key)) {
            setStore(key, value);
        }
    } else if (infosFromCookie) {
        if (value !== getCookie(key)) {
            setCookie(key, value);
        }
    } else if (infosFromLocalStorage) {
        if (JSON.stringify(value) !== getStore(key)) {
            setCookie(key, value);
        }
    }
};
/**
 * 获取全局 store
 * @param {String} key
 */
const getGlobalStore = key => {
    let infosFromCookie = getCookie(key);
    let infosFromLocalStorage = getStore(key);
    if (infosFromCookie != null) {
        return JSON.parse(infosFromCookie);
    } else if (infosFromLocalStorage != null) {
        return JSON.parse(infosFromLocalStorage);
    } else {
        return null;
    }
};
/**
 * 退出页面
 */
const exitPage = hrefString => {
    getWindow().location.href = hrefString || DEFAULT_LOGOUT_URL;
};

//查询加密开关
const getAesSwitch = (params, callback) => {
    if (getStore("rockin") === null) {
        let gziptools = new Gzip();
        let gzipSwitch = getGlobalStore("gzip");
        let reqData = {
            sysParamJson: {
                busiaction: langCheck("0000PUB-000341"), /* 国际化处理： 查询请求aes加密开关*/
                pagecs: cookiets,
            },
        };
        // 加签
        let headers = getIdentifications(reqData, params.headers || {});
        reqData = gzipSwitch ? gziptools.zip(JSON.stringify(reqData)) : reqData;
        Axios({
            url: '/nccloud/platform/aes/switch.do',
            method: "post",
            data: reqData,
            headers,
        }).then(asd => { // aesSwitchData
            if (asd.data) {
                const asdData = typeof asd.data !== 'string' ? JSON.stringify(asd.data) : asd.data; //先stringify防止parse时报错
                let gData = gzipSwitch == '1' ? gziptools.unzip(asdData) : JSON.parse(asdData);
                if (gData.success) {
                    setStore('rockin', gData.data);
                    Cipher.CipherFlag = gData.data;
                    callback && callback();
                }
            }
        });
    } else {
        callback && callback();
    }
};
export default Ajax;
